<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    title="新增授权码"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="900px"
    top="10vh"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
  >
    <el-form :model="item" ref="itemform" label-width="120px" :rules="rules">
      <el-form-item label="授权类型" prop="Type">
        <el-radio-group v-model="Type">
          <el-radio :label="0">仅软件</el-radio>
          <el-radio :label="1">软硬件</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="授权码数量" prop="Number" v-if="Type == 0">
        <el-input-number
          v-model="item.Number"
          :min="1"
          :max="10"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="业务类型" prop="BusinessTypeID">
        <select2
          style="width: 100%"
          v-model="item.BusinessTypeID"
          url="basic?type=BusinessType"
          :clearable="true"
          placeholder="请选择业务类型"
          noDataText="无类型"
        ></select2>
      </el-form-item>
      <el-form-item label="产品名称" prop="SoftwareID">
        <select2
          style="width: 100%"
          v-model="item.SoftwareID"
          :url="softwareUrl"
          placeholder="请选择产品"
          :disabled="!item.BusinessTypeID"
          :clearable="true"
          no-data-text="无产品"
          :emptyValue="0"
        ></select2>
      </el-form-item>
      <el-form-item label="产品版本" prop="TargetVersion">
        <select2
          style="width: 100%"
          v-model="item.TargetVersion"
          :url="versionUrl"
          placeholder="请选择版本"
          no-data-text="无版本"
          :disabled="!item.SoftwareID"
          :clearable="true"
          labelName="Version"
          valueKey="Version"
        ></select2>
      </el-form-item>
      <el-form-item label="功能版本" prop="FunctionID">
        <select2
          style="width: 100%"
          v-model="item.FunctionID"
          :url="functionUrl"
          :clearable="true"
          :disabled="!item.TargetVersion"
          placeholder="请选择版本"
          no-data-text="无版本"
          labelName="Name"
          valueKey="ID"
        ></select2>
      </el-form-item>
      <el-form-item label="相关硬件产品" prop="IpcProductIDs" v-if="Type == 1">
        <div class="edit_dev">
          <el-transfer
            style="text-align: left; display: inline-block"
            filter-placeholder="请输入产品SN"
            v-model="item.IpcProductIDs"
            :data="productList"
            :titles="['所有产品', '选择产品']"
            @mouseover.native="addTitle"
          >
          </el-transfer>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      item: {},
      rules: {
        Number: [
          {
            required: true,
            message: "授权码数量不能为空",
            trigger: ["blur", "change"],
          },
        ],
        BusinessTypeID: [
          {
            required: true,
            message: "请选择业务类型",
            trigger: ["blur"],
          },
        ],
        SoftwareID: [
          {
            required: true,
            message: "请选择产品",
            trigger: ["blur"],
          },
        ],
        TargetVersion: [
          {
            required: true,
            message: "请选择产品版本",
            trigger: ["blur"],
          },
        ],
        FunctionID: [
          {
            required: true,
            message: "请选择功能版本",
            trigger: ["blur"],
          },
        ],
        IpcProductIDs: [
          {
            required: true,
            message: "请选择相关硬件产品",
            trigger: ["blur", "change"],
          },
        ],
      },
      Type: 0,
      productList: [],
      pager: {
        total: 0,
        page: 1,
        size: -1,
      },
      submitting: false,
      versionUrl: "",
      softwareUrl: "",
      functionUrl: "",
      Version: {},
      versionID: null,
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  watch: {
    Type: {
      handler() {
        this.item = {};
        this.$refs.itemform.resetFields();
      },
    },
    "item.BusinessTypeID": {
      handler() {
        this.$set(this.item, "SoftwareID", null);
        this.softwareUrl = `software?Main=2&&order=spe_nb&&where[BusinessTypeID]=${this.item.BusinessTypeID}`;
      },
    },
    "item.SoftwareID": {
      handler() {
        this.$set(this.item, "TargetVersion", null);
        this.versionUrl = `software/version?where[SoftwareID]=${this.item.SoftwareID}&where[Status]=1`;
        this.$axios
          .get(this.versionUrl, {
            params: {
              where: { SoftwareID: this.item.SoftwareID },
            },
          })
          .then((response) => {
            this.Version = response.data.data;
          });
      },
    },
    "item.TargetVersion": {
      handler() {
        this.$set(this.item, "FunctionID", null);
        if (this.Version.length > 0) {
          for (const version of this.Version) {
            if (version.Version === this.item.TargetVersion) {
              this.versionID = version.ID;
              break;
            }
          }
          this.functionUrl = `functionversion?where[VersionID]=${this.versionID}`;
        }
      },
    },
  },
  methods: {
    onOpen() {
      this.getProductList();
    },
    getProductList() {
      this.$axios
        .get("ipc/product/stock-list", {
          params: {
            where: {
              Status: 2, //已出库
            },
            with: ["IpcProductModel"],
            noCode: true,
            ...this.pager,
            order: ["-sn"],
          },
        })
        .then((response) => {
          const data = response.data.data;
          this.productList = [];
          data.forEach((pro) => {
            this.productList.push({
              label: pro.IpcProductModel.Name + "_" + pro.SN,
              key: pro.ID,
              disabled: false,
            });
          });
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.item = {}; //.TargetVersion = "";
      this.$refs.itemform.resetFields();
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) return;
        this.submitting = true;
        this.$emit("input", this.item);
        const itemData = { ...this.item };
        itemData.ContractID = parseInt(this.$route.params.ID, 10);

        if (this.Type == 0) {
          // 仅增加软件授权码
          this.$axios
            .request({
              url: "ipccode",
              method: "post",
              data: itemData,
            })
            .then(() => {
              this.$message.success("新增成功");
              this.submitting = false;
              this.$emit(itemData.ID ? "form:updated" : "form:created", true);
              this.$emit("form:saved", true);
              this.$emit("update:visible", false);
            })
            .catch(({ response }) => {
              this.$sys.alarmResponse(response);
              this.submitting = false;
              this.$emit(itemData.ID ? "form:updated" : "form:created", false);
              this.$emit("form:saved", false);
            });
        } else {
          // 增加软件授权码同时与选择的硬件产品关联
          this.$axios
            .request({
              url: "ipccode/withProducts",
              method: "post",
              data: itemData,
            })
            .then(() => {
              this.$message.success("新增成功");
              this.submitting = false;
              this.$emit(itemData.ID ? "form:updated" : "form:created", true);
              this.$emit("form:saved", true);
              this.$emit("update:visible", false);
            })
            .catch(({ response }) => {
              this.$sys.alarmResponse(response);
              this.submitting = false;
              this.$emit(itemData.ID ? "form:updated" : "form:created", false);
              this.$emit("form:saved", false);
            });
        }
      });
    },
    addTitle(e) {
      const target = e.target;
      if (target.title) return;
      target.title = target.innerText;
    },
  },
};
</script>
<style  lang="scss" scoped>
// .edit_dev >>> .el-transfer-panel {
//   width: 250px;
// }
.el-transfer ::v-deep .el-transfer-panel {
  width: 340px;
}
.el-transfer ::v-deep .el-transfer__buttons {
  padding-left: 10px;
  padding-right: 10px;
}
.el-tree-node__label {
  overflow: hidden;
  word-break: keep-all;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.el-transfer ::v-deep .el-transfer-panel__item.el-checkbox .el-checkbox__label {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-left: 24px;
  line-height: 30px;
  font-size: small;
}
</style>